// import screen2 from '../../../images/screen1-0';
import screen2 from '../../../images/mockups/14-portrait.png';

function FirstContentB() {
  return (
    <div className="flex flex-col items-center w-screen overflow-hidden">
      <div className="flex flex-row-reverse justify-between pb-60 m10:flex-col items-center max-w-7xl w-full px-10 m6:px-5" id="FirstContentB-wrapper">
        <div className="w-3/5 m10:w-full">
          <div className="text-6xl m6:text-4xl m10:text-center m6:font-bold" id='first-compB-slogan'>
            Maintenance préventive
          </div>
          <div className="pt-5 text-2xl m10:text-center" id='first-compB-description'>
            Planifiez aisément des ordres de travail récurrents afin de permettre à vos experts de résoudre efficacement à l'avance des altérations de machines qui engendreraient des coûts.
          </div>
        </div>
        <div className="flex items-center justify-center m10:pt-20 " id='first-compB-left-side'>
          <img src={screen2} className="w-96" id='first-compB-screen' alt='screen2' />
        </div>
      </div>
    </div>
  );
}

export default FirstContentB;